import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from './translatable-model';
import { Property } from "./property.model";

/**
 * @class NumberingSettings
 * @property {number} id
 * @property {string} name
 * @property {number} starting_index_number
 * @property {Property} property
 */
export class NumberingSettings extends TranslatableModel {}

AccessorsMutatorsDecorator(
    'id', 
    // ...NumberingSettings.translatableAttributesWithLanguageAliases, 
    'name',
    'name_ar',
    'prefix', 
    'starting_index_number',
    'property_id'
)(NumberingSettings);



// WEBPACK FOOTER //
// ./src/pms-api/models/numbering-settings.model.js